import { FONT_WEIGHT } from '../../foundations/typography';
import { KubitPillSizeType, KubitPillVariantType, TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    kubitPill: {
        variant: KubitPillVariantType.REGULAR,
        size: KubitPillSizeType.DEFAULT,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_comp_forms_pill_unselected_font,
    },
});
export const labelSelectedCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT).label,
    font_weight: FONT_WEIGHT.font_weight_600,
    color: FOUNDATIONS.color_accent_selected_onselected_font_50,
});
export const labelDisabledCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT).label,
    color: FOUNDATIONS.color_accent_disabled_font_100,
});
export const labelDisabledSelectedCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT).label,
    font_weight: FONT_WEIGHT.font_weight_600,
    color: FOUNDATIONS.color_accent_disabled_font_50,
});
//# sourceMappingURL=commonStyles.js.map